module.exports = __webpack_public_path__ + "img/bg.91a09b0f.png";